import { memo, cloneElement } from 'react';

const MyIcon = ({ icon, onClick, ...otherProps }) => {
  return (
    <span className="anticon" onClick={onClick}>
      {cloneElement(icon, {
        ...otherProps,
      })}
    </span>
  );
};

export default memo(MyIcon);
